import React, { useMemo } from "react";
import { chartColors } from "../../../Shared/colors";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

import { useGetDashboardCompleteQuery } from "../../../features/employeeSlice";
import { 
  PendingTaskContainer, 
  CustomTooltip, 
  ChartSkeleton,
  TaskLegend 
} from "../../../Shared/ChartComponents";


export const PendingTask = ({staff}) => {
  const { data: dashboardData, isFetching } = useGetDashboardCompleteQuery({staffId: staff?.id});

  const data = useMemo(() => {
    if (!dashboardData?.taskReport) {
      return [];
    }
    
    const taskData = [
      {
        name: "One Task",
        value: dashboardData.taskReport.oneTask || 0,
        color: chartColors.success,
      },
      {
        name: "Two Tasks", 
        value: dashboardData.taskReport.twoTasks || 0,
        color: chartColors.warning,
      },
      {
        name: "More Than Two",
        value: dashboardData.taskReport.moreThanTwoTasks || 0,
        color: chartColors.danger,
      }
    ];
    
    return taskData;
  }, [dashboardData]);

  if (isFetching) {
    return <ChartSkeleton />;
  }

  return (
    <PendingTaskContainer>
      <div className="chart-header">
        <div>
          <h3 className="chart-title">Task Distribution</h3>
          <p className="chart-subtitle">Current task load analysis</p>
        </div>
      </div>
      
      <div style={{ width: '100%', height: '300px' }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data}
            margin={{
              top: 20,
              right: 30,
              left: 20,
              bottom: 20,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis 
              dataKey="name" 
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 12, fill: '#666' }}
            />
            <YAxis 
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 12, fill: '#666' }}
            />
            <Tooltip content={<CustomTooltip />} />
            <Bar 
              dataKey="value" 
              radius={[4, 4, 0, 0]}
              maxBarSize={60}
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
      
      <TaskLegend data={data} />
    </PendingTaskContainer>
  );
};

